import userManager from 'common/services/apiService/authentication/userManager';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  if (userManager.isLoggedIn()) return <Outlet />;
  else return <Navigate to="/unauthorized" replace />;
};

export default PrivateRoute;
